import { TableV2, TableV2Props } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export type AnalyticsComparePostsTableProps<TData, TValue> = TableV2Props<TData, TValue>;
export const AnalyticsComparePostsTable = <TData, TValue>({
  className,
  hasBorder = false,
  noTopBorderRadius = true,
  ...restProps
}: AnalyticsComparePostsTableProps<TData, TValue>) => (
  <TableV2
    hasBorder={hasBorder}
    noTopBorderRadius={noTopBorderRadius}
    className={cn(
      'border-b border-border [&_.table-container]:overflow-hidden',
      '[&_[data-slot="table-cell"]:first-of-type]:border-r-border',
      '[&_[data-slot="table-cell"]:last-of-type]:px-0!',
      className
    )}
    {...restProps}
  />
);
